const pushAuthenticationEvent = (event, parameters) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...parameters });
};

export const getBrowserOrPWA = () => {
  if (typeof window === "undefined") return "browser";

  return window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone
    ? "pwa"
    : "browser";
};

export const getBrowserName = () => {
  const userAgent = navigator.userAgent;

  if (/edg/i.test(userAgent)) return "edge";
  if (/firefox|fxios/i.test(userAgent)) return "firefox";
  if (/crios|chrome|chromium/i.test(userAgent)) return "chrome";
  if (/safari/i.test(userAgent)) return "safari";

  return "unknown";
};

export function sendLoginEventToGTAG(
  email,
  userRole,
  employee_id,
  browserOrPWA
) {
  pushAuthenticationEvent("ag_authentication_login", {
    USER_ROLE: userRole,
    BROWSER_OR_PWA: browserOrPWA,
    EMAIL: email,
    EMPLOYEE_ID: employee_id,
  });
}

export function sendLoginFailureEventToGTAG(failureReason, email) {
  pushAuthenticationEvent("ag_authentication_login_failure", {
    FAILURE_REASON: failureReason,
    EMAIL: email,
  });
}

export function sendSessionStartEventToGTAG(userRole, branchCode, entryPoint) {
  pushAuthenticationEvent("ag_authentication_session_startnsm", {
    USER_ROLE: userRole,
    BRANCH_NAME: branchCode,
    ENTRY_POINT: entryPoint,
  });
}

export function sendIOSPWAInstallPromptShownEventToGTAG(browser) {
  pushAuthenticationEvent("ag_authentication_ios_pwa_install_prompt_shownnew", {
    DEVICE_OS: "ios",
    BROWSER: browser,
  });
}

export function sendIOSPWAInstallInitiatedEventToGTAG(browser) {
  pushAuthenticationEvent("ag_authentication_ios_pwa_install_initiatednew", {
    DEVICE_OS: "ios",
    BROWSER: browser,
  });
}

export const pushToDataLayerForGTM = (data) => {
  console.log("Pushing to GTM data layer:", data);
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
};
